import InitComponent from 'Modules/InitComponent';
import VideoModal from './components/VideoModal.vue';
import store from 'Stores/store';

const counselorVideoModal = document.getElementById(
  'counselor-video-modal__vue'
);

if (counselorVideoModal) {
  const initCounselorVideoModal = new InitComponent({
    selectors: counselorVideoModal,
    components: { VideoModal },
    template: `<VideoModal />`,
    store,
  });

  initCounselorVideoModal.init();
}
